function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.182 0A2.193 2.193 0 000 2.182v11.636C0 15.015.985 16 2.182 16h9.09a.727.727 0 00.515-.213l4-4a.727.727 0 00.213-.514V2.182A2.193 2.193 0 0013.818 0H2.182zm0 1.455h11.636c.411 0 .728.316.728.727v8.727h-2.182c-.804 0-1.455.651-1.455 1.455v2.181H2.182a.716.716 0 01-.727-.727V2.182c0-.411.316-.727.727-.727zM4.364 5.09a.727.727 0 100 1.454h2.909a.727.727 0 100-1.454h-2.91zm5.818 0a.727.727 0 100 1.454h1.454a.727.727 0 100-1.454h-1.454zM4.364 8a.727.727 0 100 1.455h5.818a.727.727 0 100-1.455H4.364z",
  fill: "#000"
}));